import React from 'react';
import { ArrowDown } from 'lucide-react';

const HowItWorksButton = () => {
  const scrollToSteps = () => {
    const el = document.getElementById('adimlar');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      onClick={scrollToSteps}
      className="group relative inline-flex items-center justify-center gap-3 bg-gradient-to-r from-indigo-500 to-[#e45078] px-8 py-3.5 rounded-full text-white font-bold tracking-wider shadow-lg shadow-[#e45078]/30 hover:shadow-xl hover:shadow-[#e45078]/40 transition-all duration-300 hover:-translate-y-1 overflow-hidden before:absolute before:inset-0 before:-translate-x-[150%] hover:before:translate-x-[150%] before:bg-gradient-to-r before:from-transparent before:via-white/30 before:to-transparent before:skew-x-[-15deg] before:transition-transform before:duration-700 before:content-['']"
    >
      <span className="relative flex h-10 w-10 -ml-4 items-center justify-center bg-white/20 rounded-full">
        <ArrowDown className="w-5 h-5 text-white relative z-10 group-hover:animate-bounce" />
      </span>
      <span className="text-lg">Nasıl Kullanılır?</span>
    </button>
  );
};

export default HowItWorksButton;
